var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "li",
    [
      _c("div", { staticClass: "row" }, [
        _vm.$userIsClient
          ? _c("img", {
              class: {
                "col-xs-6": _vm.$userIsClient,
                "col-xs-0": _vm.$userIsAdmin || _vm.$userIsManager,
              },
              attrs: { src: _vm.talent.profile_image_url },
            })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "col-md-12 col-lg-12 response-col",
            class: {
              "col-xs-6": _vm.$userIsClient,
              "col-xs-12": _vm.$userIsAdmin || _vm.$userIsManager,
            },
          },
          [
            _c(
              "div",
              {
                class: {
                  "col-lg-9 col-md-7 col-sm-12 col-xs-12":
                    _vm.$userIsAdmin || _vm.$userIsManager,
                  "col-lg-9 col-md-9 col-sm-12 col-xs-12":
                    _vm.$userIsClient &&
                    _vm.talent.response.expiry_date === null,
                },
              },
              [_c("h3", [_vm._v(_vm._s(_vm.talent.name))])]
            ),
            _vm._v(" "),
            _vm.$userIsAdmin || _vm.$userIsManager
              ? _c(
                  "div",
                  {
                    staticClass:
                      "col-xs-12 col-sm-6 col-md-4 col-lg-3 spacer-y-1",
                    class: {
                      "col-lg-offset-3 col-md-offset-4": _vm.$userIsManager,
                    },
                  },
                  [
                    _c(
                      "ladda-button",
                      {
                        staticClass: "btn btn-red btn-block",
                        attrs: { click: _vm.handleRemoveTalentCallback },
                      },
                      [
                        _c("i", { staticClass: "fa fa-trash" }),
                        _vm._v(" Remove\n        "),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticStyle: { height: "2px" } }),
      _vm._v(" "),
      _c("booking-talent-response-decline-modal", {
        ref: "modal",
        attrs: { booking: _vm.booking },
        on: {
          "comment-added": (comment) => {
            this.comment = comment
            this.decline_modal_submitted = true
          },
        },
        model: {
          value: _vm.declineRequestReason,
          callback: function ($$v) {
            _vm.declineRequestReason = $$v
          },
          expression: "declineRequestReason",
        },
      }),
      _vm._v(" "),
      _vm.booking.has_date_options_only
        ? _c("booking-talent-date-applied-for-modal", {
            attrs: {
              talentId: _vm.talent.id,
              booking: _vm.booking,
              dates: _vm.booking.date_options,
            },
            model: {
              value: _vm.dateAppliedFor,
              callback: function ($$v) {
                _vm.dateAppliedFor = $$v
              },
              expression: "dateAppliedFor",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }